module.exports = __webpack_public_path__ + "img/80595280_1474931042675717_5212886967766745088_n.a2b8d5d2.jpg";